import { render, staticRenderFns } from "./CvSuggestionPanel.vue?vue&type=template&id=c4b3d842&scoped=true"
import script from "./CvSuggestionPanel.vue?vue&type=script&lang=js"
export * from "./CvSuggestionPanel.vue?vue&type=script&lang=js"
import style0 from "./CvSuggestionPanel.vue?vue&type=style&index=0&id=c4b3d842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b3d842",
  null
  
)

export default component.exports